import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { Clock, DollarSign, Zap, TrendingUp, Shield, Users } from 'lucide-react'

interface KeyBenefitsSectionProps {
  className?: string
}

const KeyBenefitsSection: React.FC<KeyBenefitsSectionProps> = ({ className }) => {
  const keyBenefits = [
    {
      icon: <Clock className="w-8 h-8 text-green-500" />,
      title: "Integration in Hours",
      description: "Get up and running within hours or a few days - no ongoing development on your end"
    },
    {
      icon: <DollarSign className="w-8 h-8 text-primary-orange" />,
      title: "Immediate Access to Billions",
      description: "Your clients get instant access to billions of dollars worth of deals from day 1"
    },
    {
      icon: <Zap className="w-8 h-8 text-blue-500" />,
      title: "Turnkey Solution",
      description: "Seamless order ingestion and processing - we handle everything from inquiry to deal close"
    },
    {
      icon: <TrendingUp className="w-8 h-8 text-purple-500" />,
      title: "Additional Revenue Lines",
      description: "Generate new revenue from your existing clients without additional development or sales costs"
    },
    {
      icon: <Shield className="w-8 h-8 text-emerald-500" />,
      title: "Zero Cost Partnership",
      description: "Become our partner at 0 cost to you - full end-to-end support included"
    },
    {
      icon: <Users className="w-8 h-8 text-indigo-500" />,
      title: "Official Partner Status",
      description: "Join the SecondLane Liquidity Highway as an official certified partner"
    }
  ]

  return (
    <div className={className}>
      <div className="flex items-center gap-2 mb-6">
        <TrendingUp className="text-green-600 dark:text-green-500" size={20} />
        <h2 className="text-xl font-semibold text-[var(--text)]">Why Partner With Us?</h2>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {keyBenefits.map((benefit, index) => (
          <Card key={index} variant="elevated" className="hover:border-primary-500/30 transition-colors">
            <CardContent className="p-4">
              <div className="flex items-start gap-3">
                <div className="p-2 bg-[var(--muted)] rounded-lg">
                  {benefit.icon}
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-[var(--foreground)] mb-1">{benefit.title}</h3>
                  <p className="text-[var(--muted-foreground)] text-sm leading-relaxed">{benefit.description}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  )
}

export default KeyBenefitsSection 